
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 64.002 64.002"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 30c-7.72 0-14 6.28-14 14s6.28 14 14 14 14-6.28 14-14-6.28-14-14-14zm0 26c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12z"}}),_c('path',{attrs:{"d":"M36 24.424v-9.22l3.858 3.376a4.54 4.54 0 006.183-.207 4.54 4.54 0 001.323-3.352 4.54 4.54 0 00-1.544-3.257L32.658.247a1.002 1.002 0 00-1.341.022L18.946 11.815a4.442 4.442 0 00-1.42 3.194 4.436 4.436 0 001.31 3.24c.846.846 1.969 1.312 3.164 1.312s2.318-.466 3.164-1.312L28 15.413v9.011c-9.905 2.014-16.843 11.269-15.915 21.45.857 9.388 8.27 16.959 17.627 17.999.779.086 1.553.129 2.321.129 4.929 0 9.583-1.768 13.3-5.094A20.032 20.032 0 0052 44c0-9.592-6.679-17.693-16-19.576zm7.999 32.994c-3.866 3.46-8.862 5.046-14.066 4.467-8.417-.936-15.085-7.746-15.856-16.193-.859-9.422 5.765-17.964 15.08-19.445A1 1 0 0030 25.26V13a1 1 0 00-1.707-.707l-4.543 4.543c-.936.936-2.565.936-3.5 0-.479-.479-.735-1.115-.724-1.792s.29-1.305.785-1.767l11.71-10.93 12.482 10.922c.532.465.838 1.111.861 1.817a2.501 2.501 0 01-.738 1.872 2.535 2.535 0 01-3.452.115l-5.517-4.827a1.001 1.001 0 00-1.658.753v12.26a1 1 0 00.843.987C43.626 27.643 50 35.11 50 44a18.028 18.028 0 01-6.001 13.418z"}})])
          )
        }
      }
    